import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { getDollarFormat } from 'utils/helpers';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line } from "recharts";
import LinearProgress from '@mui/material/LinearProgress';
// Basic Components
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import Button from 'screens/components/basic/Button';
import { getSales } from 'actions/DashboardActions';
class TotalSales extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeView: "week"
        }

        this.clickSaleDay = this.clickSaleDay.bind(this);
        this.clickSaleWeek = this.clickSaleWeek.bind(this);
        this.clickSaleMonth = this.clickSaleMonth.bind(this);
        this.CustomTooltip = this.CustomTooltip.bind(this);
    }

    clickSaleDay() {
        this.props.handleSalesFilter("day");
        this.setState({
            activeView: "day"
        })
    }

    clickSaleWeek() {
        this.props.handleSalesFilter("week");
        this.setState({
            activeView: "week"
        });
    }

    clickSaleMonth() {
        this.props.handleSalesFilter("month");
        this.setState({
            activeView: "month"
        });
    }

    CustomTooltip({ payload, label, active }) {
        if (active) {
            let data = payload[0].payload;
            return (

                <div className="custom-tooltip">
                    {this.state.activeView != "day" ?
                        <p><span className="custom-tooltip-prev">{`${data.prevPeriod != "" ? moment(data.prevPeriod).format("MMM-DD") : "-"}`} </span>|
                            <span className="custom-tooltip-current"> {`${data.period != "" ? moment(data.period).format("MMM-DD") : "-"}`} </span></p>
                        :
                        <p>{data.period}</p>
                    }
                    <p>Net Sales:  <span className="custom-tooltip-prev">{`${data.totalAmount_prev}`} </span>| <span className="custom-tooltip-current">{`${data.totalAmount_curr}`}</span> </p>
                    <p>Transaction Count: <span className="custom-tooltip-prev">{`${data.total_prev}`} </span>| <span className="custom-tooltip-current">{`${data.total_curr}`}</span></p>
                </div>
            );
        }

        return null;
    }

    getName = () => {
        switch (this.state.activeView) {
            case "day":
                return ["Yesderday", "Today"];
            case "week":
                return ["Last Week", "This Week"];
            case "month":
                return ["Last Month", "This Month"]
        }
    }

    getDataKey = () => {
        switch (this.state.activeView) {
            case "day":
                return "period"
            case "week":
                return "dayOfWeek"
            case "month":
                return "dayOfMonth"
        }
    }

    getData(sales, type) {
        let finalArray = [];
        if ((sales || []).length > 0) {
            finalArray = sales.map((item) => (
                {
                    [`period`]: item.period,
                    [`total_${type}`]: item.total,
                    [`totalAmount_${type}`]: (+item.totalAmount || 0).toFixed(2),
                    dayOfWeek: moment(item.period).format("ddd"),
                    dayOfMonth: parseInt(item.period.slice(-2))
                })
            );
        }
        return finalArray
    }

    combineForPlotting = (sales, prevSales, activeView) => {
        let combinedArray = []
        switch (activeView) {
            case "day":
                {
                    let tempArray = sales.concat(prevSales);

                    tempArray.forEach(element => {
                        let data = {
                            period: element.period,
                            totalAmount_curr: element.totalAmount_curr || 0,
                            total_curr: element.total_curr || 0,
                            totalAmount_prev: element.totalAmount_prev || 0,
                            total_prev: element.total_prev || 0
                        }

                        combinedArray.push(data)
                    });

                    combinedArray.sort((a, b) => new Date('1900-01-01 ' + a.period) - new Date('1900-01-01 ' + b.period))

                    return combinedArray;
                }
            case "week":
                {
                    let currentDate = moment().day(0);
                    let prevDate = moment(currentDate).clone().subtract(7, "days");
                    
                    // create a datapoint for each day of the week
                    for (let i = 0; i < 7; i++) {
                        let data = sales.filter(x => x.period == currentDate.format("YYYY-MM-DD"));
                        let prevData = prevSales.filter(x => x.period == prevDate.format("YYYY-MM-DD"));

                        let dayData = {
                            dayOfWeek: moment(currentDate).format("ddd"),
                            period: currentDate.toDate(),
                            prevPeriod: prevDate.toDate(),
                            totalAmount_curr: data.length > 0 ? data[0].totalAmount_curr : 0,
                            total_curr: data.length > 0 ? data[0].total_curr : 0,
                            totalAmount_prev: prevData.length > 0 ? prevData[0].totalAmount_prev : 0,
                            total_prev: prevData.length > 0 ? prevData[0].total_prev : 0
                        }

                        

                        combinedArray.push(dayData);

                        currentDate = moment(currentDate).add(1, "days");
                        prevDate = moment(prevDate).add(1, "days");
                    }
                    return combinedArray
                }
            case "month":
                {
                    let endOfMonth = moment().endOf("month");
                    let endOfPrevMonth = moment().subtract(1, "month").endOf("month");

                    // create a datapoint for each day of the month
                    for (let i = 1; i < 32; i++) {
                        let data = sales.filter(x => x.dayOfMonth == i);
                        let prevData = prevSales.filter(x => x.dayOfMonth == i);

                        let dayData = {
                            dayOfMonth: i,
                            period: i <= endOfMonth.date() ? moment(`${endOfMonth.format("MMM")}-${i}`, "MMM-DD") : "",
                            prevPeriod: i <= endOfPrevMonth.date() ? moment(`${endOfPrevMonth.format("MMM")}-${i}`, "MMM-DD") : "",
                            totalAmount_curr: data.length > 0 ? data[0].totalAmount_curr : 0,
                            total_curr: data.length > 0 ? data[0].total_curr : 0,
                            totalAmount_prev: prevData.length > 0 ? prevData[0].totalAmount_prev : 0,
                            total_prev: prevData.length > 0 ? prevData[0].total_prev : 0
                        }

                        combinedArray.push(dayData);
                    }
                    return combinedArray
                }
        }
    }
    

    render() {

        let sales = this.props.sales;

        let currentSales = this.getData(sales.data, "curr");
        let prevSales = this.getData(sales.prevPeriodData, "prev");

        let combinedSales = this.combineForPlotting(currentSales, prevSales, this.state.activeView);

        return (
            <div id="chart6" className="sm-item col-4-p-0">
                <DashDialog
                    text="Sales"
                    link="/report/product-sales"
                    classicClass="bg-ClassicBlue"
                    isReport={true}
                    refreshAction={() => this.props.getSales({ branchId: this.props.branchId, periodFilter: 'week'})} />
                <div className="salesGraphValue">
                    <div className="col-lg-4 d-inGrid">
                        <div className="d-flx justify-content-center">
                            <svg version="1.1" id="Layer_1" className="salesGraphSize" x="0px" y="0px" viewBox="0 0 40 40">
                                <polygon className="graphColorImg" points="39.38,9 28.9,11.1 32.04,14.24 22.62,23.67 14.24,15.29 0.62,28.9 2.72,31 14.24,19.48 22.62,27.85
                                34.14,16.33 37.28,19.48 "/>
                            </svg>
                            <span className="db-title position-relative bottom-12px pl-1 purpleText">Net Sales (+Tax)</span>
                        </div>
                        <p className="salesAmount_fit greenColorSalesNumber">{getDollarFormat(sales.totalAmount)}</p>
                    </div>
                    <div className="col-lg-4 d-inGrid">
                        <div className="d-flx justify-content-center">
                            <svg version="1.1" id="Layer_1" className="salesGraphSize" x="0px" y="0px" viewBox="0 0 40 40">
                                <polygon className="graphColorImg" points="39.38,9 28.9,11.1 32.04,14.24 22.62,23.67 14.24,15.29 0.62,28.9 2.72,31 14.24,19.48 22.62,27.85
                                34.14,16.33 37.28,19.48 "/>
                            </svg>
                            <span className="db-title position-relative bottom-12px pl-1 purpleText">Net Sales</span>
                        </div>
                        <p className="salesAmount_fit greenColorSalesNumber">{getDollarFormat(sales.netSales)}</p>
                    </div>
                    <div className="col-lg-4 d-inGrid">
                        <div className="d-flx justify-content-center">
                            <svg version="1.1" id="Layer_1" className="salesGraphSize" x="0px" y="0px" viewBox="0 0 40 40">
                                <polygon className="graphColorImg" points="39.38,9 28.9,11.1 32.04,14.24 22.62,23.67 14.24,15.29 0.62,28.9 2.72,31 14.24,19.48 22.62,27.85
                                34.14,16.33 37.28,19.48 "/>
                            </svg>
                            <span className="db-title position-relative bottom-12px pl-1 purpleText">Gross Profit</span>
                        </div>
                        <p className="salesAmount_fit greenColorSalesNumber">{getDollarFormat(sales.grossProfit)}</p>
                    </div>
                </div>
                {
                    this.props.loading
                        ?
                        <LinearProgress variant="indeterminate" />
                        :
                        <div className="sales_height position-relative">
                            <div>
                                {
                                    (sales.data || []).length > 0 || (sales.prevPeriodData || []).length > 0
                                        ?
                                        (this.state.activeView != "day" ?
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={combinedSales}
                                                    margin={{ top: 30, right: 30, left: 20, bottom: 5 }}
                                                >
                                                    <XAxis dataKey={this.getDataKey()} />
                                                    <YAxis />
                                                    <Tooltip content={this.CustomTooltip} />
                                                    <Bar dataKey="totalAmount_prev" fill="#6c9ae6" name={this.getName()[0]} label={{ position: 'center' }} barSize={20} />
                                                    <Bar dataKey="totalAmount_curr" fill="#7a60e5" name={this.getName()[1]} label={{ position: 'center' }} barSize={20} />
                                                    <Legend />
                                                </BarChart>
                                            </ResponsiveContainer>
                                            :
                                            <ResponsiveContainer width="100%" height={300}>
                                                <LineChart data={combinedSales}
                                                    margin={{ top: 30, right: 30, left: 20, bottom: 5 }}
                                                >
                                                    <XAxis dataKey={this.getDataKey()} />
                                                    <YAxis />
                                                    <Tooltip content={this.CustomTooltip} />
                                                    <Line dataKey="totalAmount_prev" name={this.getName()[0]} type="monotone" stroke="#6c9ae6" />
                                                    <Line dataKey="totalAmount_curr" name={this.getName()[1]} type="monotone" stroke="#7a60e5" />
                                                    <Legend />
                                                </LineChart>
                                            </ResponsiveContainer>
                                        )
                                        :
                                        <div>
                                            <h2 className="table_msg mt_-5">NO SALES TO DISPLAY</h2>
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={[]}
                                                    margin={{ top: 30, right: 30, left: 20, bottom: 5 }}
                                                >
                                                    <XAxis />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="totalAmount" fill="#9580ea" />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                }

                            </div>
                            <div>
                                <Button name="buttonAll"
                                    type="dashboardButton"
                                    className={this.state.activeView == "day" ? "db-btns btn-selected noPaddingBtn" : "db-btns noPaddingBtn"}
                                    label="Day"
                                    primary={true}
                                    onTouchTap={this.clickSaleDay}
                                />
                                <Button name="buttonSave"
                                    type="dashboardButton"
                                    className={this.state.activeView == "week" ? "db-btns btn-selected noPaddingBtn" : "db-btns noPaddingBtn"}
                                    label="Week"
                                    primary={true}
                                    onTouchTap={this.clickSaleWeek}
                                />
                                <Button name="buttonCancel"
                                    type="dashboardButton"
                                    className={this.state.activeView == "month" ? "db-btns btn-selected btn-space noPaddingBtn" : "db-btns btn-space noPaddingBtn"}
                                    label="Month"
                                    primary={true}
                                    onTouchTap={this.clickSaleMonth}
                                />
                            </div>
                        </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbTotalSales > 0,
        branchId: state.common.branchId,
    }
}

function mapDispatchToProps(dispatch){
    return {
        getSales: (branchId) => dispatch(getSales(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TotalSales);
